"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._useChangeReviewer = exports.useChangeReviewer = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_query_1 = require("react-query");
const FormalReviewClient_1 = require("client/FormalReviewClient");
const ChangeReviewerKeys_1 = __importDefault(require("consts/queryKeys/ChangeReviewerKeys"));
const HelperUtils_1 = require("utils/HelperUtils");
const useChangeReviewer = (cycleId, params, options) => {
    const { data, ...rest } = (0, exports._useChangeReviewer)(cycleId, params, options);
    return {
        data: data ? (0, HelperUtils_1.flattenPages)(data?.pages) : [],
        metadata: data?.pages[0].metadata?.metadata,
        ...rest
    };
};
exports.useChangeReviewer = useChangeReviewer;
const _useChangeReviewer = (cycleId, params, options) => {
    const fetchRevieweeSelections = (olderThan) => {
        const queryParams = {
            ...params,
            ...(olderThan && { olderThan })
        };
        return (0, FormalReviewClient_1.getRevieweeSelections)(cycleId, queryParams);
    };
    return (0, react_query_1.useInfiniteQuery)(ChangeReviewerKeys_1.default.selections(params), ({ pageParam }) => fetchRevieweeSelections(pageParam), {
        cacheTime: 0,
        getNextPageParam: (lastPage) => lastPage?.pagination?.next?.olderThan || null,
        ...options
    });
};
exports._useChangeReviewer = _useChangeReviewer;
